import React from 'react'
import PropTypes from 'prop-types'
import GoogleAnalytics from 'react-ga'

GoogleAnalytics.initialize('UA-97963897-1', { debug: false })

// Since this is a SPA, we have to "manually" follow URL changes to make GA useful
function trackPage(pathname, search) {
  GoogleAnalytics.set({ page: pathname + search })
  GoogleAnalytics.pageview(pathname + search)
}

// HOC that wraps app to track history
const withGATracker = WrappedComponent => {
  const TrackedComponent = props => {
    const { pathname, search } = props.location

    // Call google analytics
    trackPage(pathname, search)

    // Send original component on its merry way
    return <WrappedComponent {...props} />
  }

  TrackedComponent.propTypes = {
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired
    }).isRequired
  }

  return TrackedComponent
}

export default withGATracker
